import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authAxios } from "setups/axios";

export const fetchUser = createAsyncThunk("user/fetchUser", async () => {
  const token = localStorage.getItem("token");

  if (!token) return {};

  const res = await authAxios()({
    url: `/api/v1/user`,
    method: "GET",
  });

  return res?.data?.data;
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    user: {},
  },
  extraReducers: {
    [fetchUser.fulfilled]: (state, action) => {
      console.log("Payload", action.payload);

      state.loading = false;
      state.user = action.payload;
    },
    [fetchUser.rejected]: (state, action) => {
      state.loading = false;
      state.user = {};
    },
    [fetchUser.pending]: (state, action) => {
      state.loading = true;
      state.user = {};
    },
  },
});

export const { getUser, setUser } = userSlice.actions;

export default userSlice.reducer;
